/** HTTP-cache warm-up only. Failed downloads never enter the browser's module map. */
export function warmAssignmentAssets(signal: AbortSignal) {
  const manifest = document.getElementById('assignment-assets')?.textContent;
  if (!manifest) return;
  let files: unknown;
  try { files = JSON.parse(manifest); } catch { return; }
  if (!Array.isArray(files)) return;
  for (const file of files) {
    if (typeof file !== 'string' || !file.startsWith('/assets/') || file.includes('..')) continue;
    // Match module fetch credentials so the subsequent import can reuse HTTP cache.
    void fetch(file, { credentials: 'same-origin', cache: 'force-cache', priority: 'low', signal }).catch(() => {});
  }
}
